import { createSlice } from "@reduxjs/toolkit";
import { triggerWelcomeCampaignAPI } from "../../services/triggerWelcomeCampaign";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const triggerWelcomeCampaignSlice = createSlice({
  name: "triggerWelcomeCampaign",
  initialState: data,
  reducers: {
    triggerWelcomeCampaignInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    triggerWelcomeCampaignInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "Welcome campaign triggered successfully";
      state.error = "";
    },
    triggerWelcomeCampaignInfoFailure(state, action) {
      state.isLoading = false;
      state.data = null;
      state.message = "";
      state.error = action.payload;
    },
    triggerWelcomeCampaignInfoReset(state) {
      state.isLoading = false;
      state.data = null;
      state.error = "";
      state.message = "";
    },
  },
});

export const triggerWelcomeCampaignHandler = (payload) => async (dispatch) => {
  try {
    dispatch(triggerWelcomeCampaignAction.triggerWelcomeCampaignInfo());
    const response = await triggerWelcomeCampaignAPI(payload);
    dispatch(triggerWelcomeCampaignAction.triggerWelcomeCampaignInfoSuccess(response));
  } catch (e) {
    const errorMessage = typeof e === "string" ? e : e?.message || "Something went wrong.";
    dispatch(triggerWelcomeCampaignAction.triggerWelcomeCampaignInfoFailure(errorMessage));
  }
};

export default triggerWelcomeCampaignSlice.reducer;
export const triggerWelcomeCampaignAction = triggerWelcomeCampaignSlice.actions;
